import React from "react";
import "./about.css";
import Menu from "../../components/menu/menu";

const About = () => {
  return (
    <>
      <Menu url="about" />
      <main className="about-page">
        <div className="about-container">
          <section className="about-section">
            <header className="about-header">
              <h1 className="about-title">
                Sobre mim
              </h1>
              <div className="title-divider"></div>
            </header>

            {/* Conteúdo principal */}
            <div className="about-content">
              <p className="intro-text">
                Desenvolvedor Full Stack apaixonado por criar soluções web modernas
                e performáticas.
              </p>

              <p className="body-text">
                Formado em{" "}
                <strong>Análise e Desenvolvimento de Sistemas</strong>, com
                experiência prática em desenvolvimento de aplicações escaláveis,
                responsivas e de alto desempenho.
              </p>

              <p className="body-text">
                Com experiência em <strong>PHP/Laravel</strong>,{" "}
                <strong>React.js</strong> e <strong>Vue.js</strong>, transformando
                requisitos complexos em soluções intuitivas e eficientes que
                entregam resultados.
              </p>


            </div>

           
          </section>
        </div>
      </main>
    </>
  );
};

export default About;
